export default __webpack_public_path__ + "static/media/discord_orange.d5acd03a.svg";